<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Ontology Viewer</div>
    <div style="width: 60%; margin:auto">
        Use an interactive ontology viewer to explore the DrugOn ontology.

        <div style="margin-top: 20px; font-weight: bold;">
            How to use the viewer and search for drugs:
            <ul style="font-weight: normal;">
                <li>First, search for a drug, target or class in the upper right field.</li>
                <li>Select a node by clicking on it to get more information in the profile.</li>
                <li>Expand or delete nodes in the viewer by clicking and holding the left mouse button on the node and then releasing it on the selected option.</li>
                <li>In the context menu, select the relationship you want to extend.<br><span style="font-weight: bold; color: red;">Warning:</span> Do not expand ontology nodes that have a size greater than 100!</li>
            </ul>
        </div>
    </div>
</div>
<div>
<iframe src="https://mtb.bioinf.med.uni-goettingen.de/ontoscope/?plugin=./ontoscope-connector"
    title="DrugOn-Web Ontology" frameborder="0" style="height:800px"></iframe>
</div>